import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {CustomObjectMultiSelectSearchControlComponent} from "./custom-object/controls/custom-object-multi-select-search-control.component";
import {CustomObjectTypeMultiSelectSearchControlComponent} from "./custom-object-type/controls/custom-object-type-multi-select-search-control.component";
import {CustomObjectMultiSelectEditControlComponent} from "./custom-object/controls/custom-object-multi-select-edit-control.component";
import {CustomObjectTypeSingleSelectEditControlComponent} from "./custom-object-type/controls/custom-object-type-single-select-edit-control.component";
import {CustomObjectSingleSelectEditControlComponent} from "./custom-object/controls/custom-object-single-select-edit-control.component";
import {InventoryCustomObjectReportSelectionControlComponent} from "./custom-object/controls/inventory-custom-object-report-selection-control.component";
import {OutletCustomObjectReportSelectionControlComponent} from "./custom-object/controls/outlet-custom-object-report-selection-control.component";
import {CustomObjectMultiSelectColumnComponent} from "./custom-object/controls/custom-object-multi-select-column.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule
    ],
    declarations: [
        CustomObjectMultiSelectSearchControlComponent,
        CustomObjectMultiSelectEditControlComponent,
        CustomObjectSingleSelectEditControlComponent,
        CustomObjectTypeMultiSelectSearchControlComponent,
        CustomObjectTypeSingleSelectEditControlComponent,
        CustomObjectMultiSelectColumnComponent,
        InventoryCustomObjectReportSelectionControlComponent,
        OutletCustomObjectReportSelectionControlComponent
    ],
    exports: [
        CustomObjectMultiSelectSearchControlComponent,
        CustomObjectMultiSelectEditControlComponent,
        CustomObjectSingleSelectEditControlComponent,
        CustomObjectTypeMultiSelectSearchControlComponent,
        CustomObjectTypeSingleSelectEditControlComponent,
        CustomObjectMultiSelectColumnComponent,
        InventoryCustomObjectReportSelectionControlComponent,
        OutletCustomObjectReportSelectionControlComponent
    ]
})
export class CustomObjectSharedModule {
}
